module.exports = __webpack_public_path__ + "r-v3/img/ml_01_00.1aaf1e25.jpg";